<div class="cancel-dialog">

  <!-- Header -->
  <div class="cancel-dialog__header">
    <div class="cancel-dialog__header-icon">
      <i class="bi bi-calendar2-x"></i>
    </div>
    <div class="cancel-dialog__header-text">
      <h2 class="cancel-dialog__title">Cancel Appointment</h2>
      <p class="cancel-dialog__subtitle-text">
        Are you sure you want to cancel this appointment?
      </p>
    </div>
    <button class="cancel-dialog__close" (click)="keepAppointment()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <!-- Loading state -->
  <div class="cancel-dialog__loader" *ngIf="isLoading">
    <div class="cancel-dialog__spinner"></div>
    <p>Fetching cancellation details...</p>
  </div>

  <!-- Error state -->
  <div class="cancel-dialog__error" *ngIf="!isLoading && hasError">
    <i class="bi bi-exclamation-octagon-fill"></i>
    <p>Unable to load cancellation preview. Please try again.</p>
    <button class="cancel-dialog__retry-btn" (click)="loadPreview()">
      <i class="bi bi-arrow-clockwise"></i> Retry
    </button>
  </div>

  <!-- Preview content -->
  <ng-container *ngIf="!isLoading && !hasError && preview">

    <!-- Refund Summary -->
    <div class="cancel-dialog__section-label">Refund Summary</div>

    <div class="cancel-dialog__line-items">
      <div class="cancel-dialog__line-item" *ngFor="let item of preview.line_items">
        <div class="cancel-dialog__item-left">
          <i class="bi cancel-dialog__item-icon"
            [ngClass]="item.refundable === true
              ? 'bi-check-circle-fill cancel-dialog__item-icon--yes'
              : 'bi-x-circle-fill cancel-dialog__item-icon--no'"></i>
          <span class="cancel-dialog__item-label">{{ item.label }}</span>
          <span class="cancel-dialog__item-tag"
            *ngIf="item.refundable === false">non-refundable</span>
        </div>
        <span class="cancel-dialog__item-amount">₹{{ item.amount | number:'1.0-0' }}</span>
      </div>
    </div>

    <!-- Divider + Paid amount -->
    <div class="cancel-dialog__divider"></div>

    <div class="cancel-dialog__paid-row">
      <span class="cancel-dialog__paid-label">
        Paid Amount
        <span class="cancel-dialog__paid-via">via Payment</span>
      </span>
      <span class="cancel-dialog__paid-amount">₹{{ preview?.totals?.paid_amount | number:'1.0-0' }}</span>
    </div>

    <!-- Refund amount highlight -->
    <div class="cancel-dialog__refund-total-row">
      <span class="cancel-dialog__refund-total-label">Refund Amount</span>
      <span class="cancel-dialog__refund-total-amount">
        ₹{{ preview?.totals?.final_amount | number:'1.0-0' }}
      </span>
    </div>

    <!-- Meta cards -->
    <div class="cancel-dialog__meta-row">
      <div class="cancel-dialog__meta-card">
        <span class="cancel-dialog__meta-icon">
          <i class="bi bi-cash-coin"></i>
        </span>
        <span class="cancel-dialog__meta-text">
          <span class="cancel-dialog__meta-title">Refund Method</span>
          <span class="cancel-dialog__meta-value">
            {{ formatRefundMethod(preview?.refund_meta?.method || '') }}
          </span>
        </span>
      </div>
      <div class="cancel-dialog__meta-card">
        <span class="cancel-dialog__meta-icon cancel-dialog__meta-icon--time">
          <i class="bi bi-hourglass-split"></i>
        </span>
        <span class="cancel-dialog__meta-text">
          <span class="cancel-dialog__meta-title">Expected Refund Time</span>
          <span class="cancel-dialog__meta-value">
            {{ preview?.refund_meta?.expected_days }} Business Days
          </span>
        </span>
      </div>
    </div>

  </ng-container>

  <!-- Warning banner -->
  <div class="cancel-dialog__warning" *ngIf="!isLoading">
    <i class="bi bi-exclamation-triangle-fill cancel-dialog__warning-icon"></i>
    <span>
      <strong>Cancellation cannot be undone.</strong>
      Once cancelled, this appointment cannot be restored.
    </span>
  </div>

  <!-- Actions -->
  <div class="cancel-dialog__actions" *ngIf="!isLoading && !hasError">
    <button class="cancel-dialog__keep-btn" (click)="keepAppointment()" [disabled]="isConfirming">
      Keep Appointment
    </button>
    <button class="cancel-dialog__confirm-btn" (click)="confirmCancel()" [disabled]="isConfirming">
      <span *ngIf="!isConfirming">Confirm Cancellation</span>
      <span *ngIf="isConfirming" class="cancel-dialog__btn-spinner"></span>
    </button>
  </div>

  <!-- Error actions -->
  <div class="cancel-dialog__actions" *ngIf="!isLoading && hasError">
    <button class="cancel-dialog__keep-btn" (click)="keepAppointment()">
      Keep Appointment
    </button>
  </div>

</div>
